import React from 'react';
import { motion } from 'framer-motion';
export function Solution() {
  return <section className="py-24 bg-zinc-50 relative overflow-hidden" data-id="element-209">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-gradient-to-b from-blue-50/50 to-transparent pointer-events-none" data-id="element-210"></div>

      <div className="max-w-4xl mx-auto px-4 md:px-6 relative z-10 text-center" data-id="element-211">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-212">
          <h2 className="text-3xl md:text-5xl font-extrabold text-zinc-900 tracking-tight mb-8" data-id="element-213">
            Por eso creé el Sistema de Publicidad para Tiendas de iPhone
          </h2>
          <p className="text-xl text-zinc-600 mb-10 leading-relaxed text-balance" data-id="element-214">
            Un curso práctico donde aprendés a analizar tu tienda, elegir qué
            modelos publicitar, crear ofertas atractivas, configurar campañas de
            mensajes y usar estrategias como plan canje para atraer compradores
            más calificados.
          </p>
          <a href="https://sistema-iphone-ads.myshopify.com/products/sistema-iphone-ads" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-blue-600 rounded-full hover:bg-blue-700 transition-colors shadow-lg hover:shadow-xl" data-id="element-215">
            Quiero acceder al sistema
          </a>
        </motion.div>
      </div>
    </section>;
}